import { SelectorSimpleFactory, SelectorEnumFactory } from "app/features/selectores/logic";

export interface ParamsEstadisticasClientes {
    fechaDesde: Date | string | null;
    fechaHasta: Date | string | null;
    tipoReporte: TipoReporteEstadisticasClientes;
    idCliente?: number | null;
    idSucursal?: number | null;
    IdVendedor?: number | null;
    orderByTotal: boolean
}

export enum TipoReporteEstadisticasClientes {
    ReportePotencialEnvio = 0,
    ReportePotencialRecepcion = 1
}


// WEBPACK FOOTER //
// ./app/models/reporteestadisticasclientes.ts